import { motion } from "framer-motion";
import { MaskedLine } from "@/components/Reveal";

export const PageHero = ({ overline, title, accent, description, image, imageAlt }) => (
  <section data-testid="page-hero" className="relative overflow-hidden bg-gradient-to-br from-navy via-deepsea to-ocean pt-36 pb-16 sm:pt-44 sm:pb-20 lg:pb-24">
    <div className="noise-overlay absolute inset-0 opacity-[0.05] pointer-events-none" />
    <div className="absolute -top-32 -right-32 w-[30rem] h-[30rem] rounded-full bg-aqua/15 blur-[110px] pointer-events-none" />
    <div className="relative px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
      <div className={`grid gap-10 items-center ${image ? "lg:grid-cols-12" : ""}`}>
        <div className={image ? "lg:col-span-7" : "max-w-3xl"}>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.1 }}
            className="text-xs font-mono uppercase tracking-[0.25em] text-sky2 font-semibold"
            data-testid="page-hero-overline"
          >
            {overline}
          </motion.p>
          <h1 className="mt-5 font-display font-extrabold tracking-tight leading-[1.08] text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="page-hero-title">
            <MaskedLine delay={0.2}>{title}</MaskedLine>
            {accent && (
              <MaskedLine delay={0.35} className="text-transparent bg-clip-text bg-gradient-to-r from-sky2 to-aqua">
                {accent}
              </MaskedLine>
            )}
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: 0.6 }}
            className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-xl"
            data-testid="page-hero-description"
          >
            {description}
          </motion.p>
        </div>
        {image && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="clip-arch overflow-hidden ring-1 ring-white/20 shadow-2xl shadow-navy/50">
              <img src={image} alt={imageAlt} className="w-full h-56 sm:h-72 lg:h-80 object-cover" loading="eager" data-testid="page-hero-image" />
            </div>
          </motion.div>
        )}
      </div>
    </div>
  </section>
);
